import { treeService } from "@/services";

angular.module("app").service("TreeManager", () => treeService);
